<template>
  <div class="cancelRules">
    <Nav :title="title" :back="back"></Nav>
    <div class="content" :class="{ isIosx: isiOSX }">
      <div class="contentTop">
        <p>
         根据阳光出行规则，因您责任导致订单取消，您需支付一定的司机补偿费，全部用于补偿司机的空驶成本。
        </p>
        <h2>您需支付司机补偿费的情况</h2>
        <p>
          若您在司机接单3分钟后取消订单，依照阳光出行的取消规则，您需要支付司机补偿费。
        </p>
        <h2>您无需支付司机补偿费的情况</h2>
        <p>1.您在司机接单3分钟内取消订单。</p>
        <p>2.司机未在规定时间内到达上车点，您取消订单。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "取消规则",
      isiOSX: false,
      back: 0,
    };
  },
  components: { Nav },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.type) {
      this.back = 1;
    }
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="less">
.cancelRules {
  background: #ffffff;
  min-height: 100%;
  .content {
    padding-top: 70px;
    margin: 0px 15px 0;
    padding-bottom: 110px;
    .contentTop {
      margin-top: 15px;
      padding-bottom: 30px;
      h2 {
        color: #181818;
        font-size: 20px;
        line-height: 28px;
        margin: 31px 0 10px;
      }
      p {
        color: #666666;
        font-size: 15px;
        line-height: 20px;
      }
    }
  }

  .isIosx {
    padding-top: 90px;
  }
}
</style>
